import { Table } from '@tanstack/react-table';

export function getFirstAndLastColumnIds<T extends object>(table: Table<T>) {
  const visibleColumns = table.getVisibleFlatColumns();
  return {
    firstColumnId: visibleColumns.at(0)?.id,
    lastColumnId: visibleColumns.at(-1)?.id,
  };
}

export function alignToJustifyContent(align: 'left' | 'center' | 'right'): string {
  switch (align) {
    case 'left':
      return 'flex-start;';
    case 'center':
      return 'center;';
    case 'right':
      return 'flex-end;';
  }
}

export const wrapOverflow = (): { style: React.CSSProperties } => ({
  style: { overflow: 'wrap', whiteSpace: 'normal' },
});
